export type SaveOptions = {
  andExitEdit: boolean;
  andNotify: boolean;
  clearReviewDiff?: boolean;
};
export const defaultSaveOptions: SaveOptions = {
  andExitEdit: false,
  andNotify: true,
};
